import { useCallback } from "react";

import { useSearchParamActions } from "./useSearchParamActions";

export function useCustomSearchParams(key) {
  const { searchParams, updateSearchParam, removeSearchParam } =
    useSearchParamActions();
  const data = searchParams.get(key);

  const setParamValue = useCallback(
    (paramKey, value) => {
      if (value === undefined) {
        updateSearchParam(key, paramKey);
        return;
      }

      updateSearchParam(paramKey, value);
    },
    [key, updateSearchParam]
  );

  const removeParamValue = useCallback(
    (paramKey = key) => {
      removeSearchParam(paramKey);
    },
    [key, removeSearchParam]
  );

  return [data, setParamValue, removeParamValue];
}
